import { useCallback, useContext, useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { SchoolContext } from '../../../Providers/SchoolProvider'

const SchoolSectionsSelector = ({ multiple = 'default', values, onChange, filter, style = {} }) => {
  const { schoolSections } = useContext(SchoolContext)

  const mapToOptions = useCallback(section => {
    const { schoolYearName, sectionAbbreviation, sectionName } = section.sectionToYear

    const suffix = ` (${schoolYearName})`

    return {
      label: sectionAbbreviation + suffix,
      value: section.id,
      tooltip: sectionName + suffix,
      entity: section
    }
  }, [])

  const sectionOptions = useMemo(() => typeof filter === 'function'
    ? schoolSections.filter(filter).map(mapToOptions)
    : schoolSections.map(mapToOptions)
  , [schoolSections, filter])

  return (
    <EntitiesSelector
      multiple={multiple}
      values={values}
      onChange={onChange}
      entityOptions={sectionOptions}
      style={{ ...style }}
    />
  )
}

export default SchoolSectionsSelector
